import {
  withTranslation,
} from 'react-i18next';

import SponsorsSectionView from './SponsorsSectionView';

const TranslatedComponent = withTranslation()(SponsorsSectionView);

const Component = TranslatedComponent;

export default Component;
